import React, { useState, useEffect } from "react";
import './JobDetails.scss';
import DataTable from 'react-data-table-component';
import { LuEye } from "react-icons/lu";
import { useNavigate, useParams } from "react-router-dom";
import JobActivity from "./jobActivity";
import { CandidateActivity } from "../candidateDetails/CandidateActivity";
import jobApi from "../../services/jobApi";
import candidateApi from "../../services/candidateApi";
import JobDetailsDTO from '../../dto/jobDetailsDto';
import { useHeaderTitle } from "../layout/layout";
import { IoChevronDown } from "react-icons/io5";

export default function Overview() {
    const { jobDetailId } = useParams();
    const [jobDetails, setJobDetails] = useState(null); 
    const [jobActivities, setJobActivities] = useState([]);
    const [candidateActivities, setCandidateActivities] = useState([]);
    const [candidateDetails, setCandidateDetails] = useState([]);
    const [candidateName, setCandidateName] = useState(null);
    const [candidateId, setCandidateId] = useState(null);
    const [highlightedRowId, setHighlightedRowId] = useState(null);
    const [overviewCount, setOverViewCount] = useState(null)
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleContent = () => setIsExpanded(prev => !prev);

    const columns = [
        {
            name: 'Name',
            selector: (row) => row?.firstName + ' ' + row?.lastName,
            width: "150px",
        },
        {
            name: 'Current Title',
            selector: (row) => row?.candidateTitle,
            width: "150px",
        },
        {
            name: 'Contact No',
            selector: (row) => row?.mobile,
            width: "135px",
        },
        {
            name: 'Email',
            selector: (row) => row?.email,
        },
        {
            name: 'Status',
            width: "125px",
            cell: (row) => (
                <div className="status primary">
                    {row?.mappingStatus || 'New'}
                </div>
            ),
        },
        {
            name: "",
            width: "50px",
            button: true,
            right: true,
            cell: (row) => (
                <div className="gridIcons d-flex gap-2" data-tag="allowRowEvents">

                    <button
                        type="button"
                        className="btn plain-btn-primary view-btn primary-color"
                        title="Details"
                        onClick={() => { fetchCandidateActivity(row?.candidateId, row?.firstName + ' ' + row?.lastName); }}

                    >
                        <LuEye />
                    </button>

                </div>
            ),
        }

    ];


    const { setHeaderTitle } = useHeaderTitle();
    useEffect(() => {
        const fetchDetails = async () => {
            let response = await jobApi.getJobOverViewById(jobDetailId);
            const jobDetails = new JobDetailsDTO(response?.data);
            console.log(response?.data);
            setJobDetails(jobDetails);
            setJobActivities(response?.data?.activities)
            setHeaderTitle('Job List  >   ' + jobDetails?.jobTitle + '- #' + jobDetails?.jobCode);
        };
        fetchDetails();        
    }, [jobDetailId,setHeaderTitle]);  
    useEffect(() => {
        console.log("Updated job activities:", jobActivities);
    }, [jobActivities]);
    useEffect(() => {
        if (candidateDetails && candidateDetails.length > 0) {
            const firstCandidate = candidateDetails[0]; // Get the first candidate
            if (firstCandidate.candidateId) {
                //setCandidateName(firstCandidate.firstName+ ' ' +firstCandidate.lastName)
                fetchCandidateActivity(firstCandidate.candidateId, firstCandidate.firstName + ' ' + firstCandidate.lastName); // Call for the first candidate
            }
        }
    }, [candidateDetails]);
    useEffect(() => {
        const fetchDetails = async () => {
          try {
            const response = await jobApi.getMappedCandidateDetailsByJobId(jobDetailId);
            console.log(response);
            setCandidateDetails(response?.data || []); // Fallback to an empty array
          } catch (error) {
            console.error("Error fetching candidate details:", error);
            setCandidateDetails([]); // Handle error case
          }
        };    
        if (jobDetailId) {
          fetchDetails();
        }
      }, [jobDetailId]);
      const fetchCandidateActivity = async (id,candidatename) => {
        try {
          setHighlightedRowId(id);
          const response = await candidateApi.getCandidateActivityDetails(id,jobDetailId);
          console.log(response);
          const resultArray = Object.values(response?.data);
          setCandidateActivities(resultArray || []); // Fallback to an empty array
          setCandidateName(candidatename)
          setCandidateId(id)

        } catch (error) {
            console.error("Error fetching candidate details:", error);
            setCandidateActivities([]); // Handle error case
        }
    };
    useEffect(() => {
        console.log("Candidate Activity", candidateActivities)
    }, [candidateActivities]);

    useEffect(() => {
        fetchJobOverViewCount()
    }, [])

    const fetchJobOverViewCount = async () => {
        try {
            const res = await jobApi.getJobOverViewCountByJobId(jobDetailId)
            if (res?.data?.[0]) {
                setOverViewCount(res.data[0])
            }

        } catch (error) {
            console.log("couldn't fetch job overview count")
        }
    }

    return (
        <section className="overview-holder">

            <div className="row overview-card-container mb-3">
                <div className="col-12 col-md-2 card-holder mb-4">
                    <div className="card p-2 card-01 h-100">
                        <div className="d-flex align-items-center">
                            <div className="left">
                                <h2 className="fw-bold">
                                    {overviewCount ? overviewCount.numberOfPositions : 0}
                                </h2>
                                <p className="mb-0">
                                    Openings
                                </p>
                            </div>
                            <div className="icon ms-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29.5" height="29.699" viewBox="0 0 29.5 29.699">
                                    <g id="chair-2-svgrepo-com" transform="translate(0.75 0.75)">
                                        <path id="Path_583" data-name="Path 583" d="M6,15.9a1.4,1.4,0,0,1,1.4-1.4h14a1.4,1.4,0,0,1,1.4,1.4A2.8,2.8,0,0,1,20,18.7H8.8A2.8,2.8,0,0,1,6,15.9Z" transform="translate(-0.4 3)" fill="none" stroke="#0583d0" stroke-width="1.5" />
                                        <path id="Path_584" data-name="Path 584" d="M6.748,8.672c.338-2.816.507-4.224,1.321-5.186a4.2,4.2,0,0,1,.893-.792C10.014,2,11.432,2,14.268,2s4.254,0,5.306.694a4.2,4.2,0,0,1,.893.792c.814.962.983,2.37,1.321,5.186l.127,1.061c.351,2.922.526,4.384-.31,5.325S19.3,16,16.356,16H12.181c-2.943,0-4.415,0-5.251-.942s-.66-2.4-.309-5.325Z" transform="translate(-0.268 -2)" fill="none" stroke="#0583d0" stroke-width="1.5" />
                                        <path id="Path_585" data-name="Path 585" d="M12,12v2.8" transform="translate(2 2)" fill="none" stroke="#0583d0" stroke-width="1.5" />
                                        <path id="Path_586" data-name="Path 586" d="M16,26.2V23.4m0,0V19.9m0,3.5.653.163A4.033,4.033,0,0,1,19.5,26.2M16,23.4l-.653.163A4.033,4.033,0,0,0,12.5,26.2M7.6,17.8,6.389,14.166a5.781,5.781,0,0,0-.253-.675,3.3,3.3,0,0,0-.222-.416C5.275,12.025,4.425,11.5,2,11.5m22.4,6.3,1.211-3.634a5.763,5.763,0,0,1,.253-.675,3.3,3.3,0,0,1,.222-.416C26.725,12.025,27.574,11.5,30,11.5" transform="translate(-2 1.8)" fill="none" stroke="#0583d0" stroke-linecap="round" stroke-width="1.5" />
                                    </g>
                                </svg>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-2 card-holder mb-4">
                    <div className="card p-2 card-02 h-100">
                        <div className="d-flex align-items-center">
                            <div className="left">
                                <h2 className="fw-bold">
                                    {overviewCount ? overviewCount.profileCount : 0}
                                </h2>
                                <p className="mb-0">
                                    Profiles
                                </p>
                            </div>
                            <div className="icon ms-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="23.05" height="25" viewBox="0 0 23.05 25">
                                    <g id="user-profile-svgrepo-com" transform="translate(-19.968)">
                                        <g id="Group_1834" data-name="Group 1834" transform="translate(27.454)">
                                            <g id="Group_1833" data-name="Group 1833">
                                                <path id="Path_589" data-name="Path 589" d="M177.319,0a4.039,4.039,0,1,0,4.039,4.04A4.043,4.043,0,0,0,177.319,0Zm0,7.3a3.258,3.258,0,1,1,3.258-3.259A3.262,3.262,0,0,1,177.319,7.3Z" transform="translate(-173.28)" fill="#23d4eb" />
                                            </g>
                                        </g>
                                        <g id="Group_1836" data-name="Group 1836" transform="translate(22.529 9.078)">
                                            <g id="Group_1835" data-name="Group 1835">
                                                <path id="Path_590" data-name="Path 590" d="M85.321,186.014l-.31-.094-3.631,2.737-3.63-2.737-.31.094a7.135,7.135,0,0,0-5.023,6.689l.008.633H90.337l.008-.633A7.135,7.135,0,0,0,85.321,186.014ZM73.2,192.554a6.269,6.269,0,0,1,4.395-5.772l3.313,2.5.47.355.47-.355,3.313-2.5a6.271,6.271,0,0,1,4.4,5.772Z" transform="translate(-72.416 -185.92)" fill="#23d4eb" />
                                            </g>
                                        </g>
                                        <g id="Group_1838" data-name="Group 1838" transform="translate(19.968 20.375)">
                                            <g id="Group_1837" data-name="Group 1837" transform="translate(0)">
                                                <rect id="Rectangle_573" data-name="Rectangle 573" width="23.05" height="0.781" fill="#23d4eb" />
                                            </g>
                                        </g>
                                        <g id="Group_1840" data-name="Group 1840" transform="translate(19.968 24.219)">
                                            <g id="Group_1839" data-name="Group 1839" transform="translate(0)">
                                                <rect id="Rectangle_574" data-name="Rectangle 574" width="23.05" height="0.781" fill="#23d4eb" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>


                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-2 card-holder mb-4">
                    <div className="card p-2 card-03 h-100">
                        <div className="d-flex align-items-center">
                            <div className="left">
                                <h2 className="fw-bold">
                                    {overviewCount ? overviewCount.shortListedCount : 0}
                                </h2>
                                <p className="mb-0">
                                    Shortlisted
                                </p>
                            </div>
                            <div className="icon ms-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21.727" height="25" viewBox="0 0 21.727 25">
                                    <g id="selected-document-file-svgrepo-com" transform="translate(-33.515)">
                                        <path id="Path_591" data-name="Path 591" d="M116.432,372.443h8.385a5.371,5.371,0,0,1,.462-1.005h-8.846v1.005Z" transform="translate(-78.868 -353.301)" fill="#34e9ed" />
                                        <rect id="Rectangle_575" data-name="Rectangle 575" width="10.508" height="1.004" transform="translate(37.563 14.064)" fill="#34e9ed" />
                                        <rect id="Rectangle_576" data-name="Rectangle 576" width="10.508" height="1.004" transform="translate(37.563 9.993)" fill="#34e9ed" />
                                        <rect id="Rectangle_577" data-name="Rectangle 577" width="4.953" height="1.004" transform="translate(43.118 5.922)" fill="#34e9ed" />
                                        <path id="Path_592" data-name="Path 592" d="M35.657,22.352a.937.937,0,0,1-.938-.937V8.1h5.732A1.15,1.15,0,0,0,41.6,6.947V1.2h8.381a.939.939,0,0,1,.937.937V15.42c.082-.007.16-.007.242-.007a5.353,5.353,0,0,1,.962.085V2.142A2.144,2.144,0,0,0,49.979,0h-8.69a2.343,2.343,0,0,0-1.666.689L34.2,6.108a2.343,2.343,0,0,0-.689,1.666V21.415a2.141,2.141,0,0,0,2.142,2.141H46.328a5.462,5.462,0,0,1-.483-1.2H35.657ZM40.529,1.488V6.3c0,.519-.2.721-.724.721H34.989Z" fill="#34e9ed" />
                                        <path id="Path_593" data-name="Path 593" d="M315.287,344.719a4.084,4.084,0,1,0,4.084,4.084A4.084,4.084,0,0,0,315.287,344.719Zm2.639,2.752-2.18,2.644a.8.8,0,0,1-1.169.1l-1.325-1.191a.5.5,0,0,1-.037-.712l.178-.2a.5.5,0,0,1,.714-.032l1.107,1.018,2.245-2.074a.324.324,0,0,1,.467.445Z" transform="translate(-264.129 -327.887)" fill="#34e9ed" />
                                    </g>
                                </svg>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-2 card-holder mb-4">
                    <div className="card p-2 card-04 h-100">
                        <div className="d-flex align-items-center">
                            <div className="left">
                                <h2 className="fw-bold">
                                    {overviewCount ? overviewCount.interviewInprogressCount : 0}
                                </h2>
                                <p className="mb-0">
                                    Interview
                                </p>
                            </div>
                            <div className="icon ms-auto">
                                <svg id="interview-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Group_1841" data-name="Group 1841">
                                        <rect id="Rectangle_578" data-name="Rectangle 578" width="1" height="1" transform="translate(9.5 13)" fill="#00b5ea" />
                                        <rect id="Rectangle_579" data-name="Rectangle 579" width="1" height="1" transform="translate(9.5 15)" fill="#00b5ea" />
                                        <path id="Path_594" data-name="Path 594" d="M16.5,6.5h1A2.476,2.476,0,0,0,20,4V2.5A2.476,2.476,0,0,0,17.5,0h-1A2.476,2.476,0,0,0,14,2.5V4A2.476,2.476,0,0,0,16.5,6.5ZM15,2.5A1.473,1.473,0,0,1,16.5,1h1A1.473,1.473,0,0,1,19,2.5V4a1.473,1.473,0,0,1-1.5,1.5h-1A1.473,1.473,0,0,1,15,4Z" transform="translate(-7)" fill="#00b5ea" />
                                        <path id="Path_595" data-name="Path 595" d="M29.5,24H16V17.5A3.478,3.478,0,0,0,12.5,14h-5A3.478,3.478,0,0,0,4,17.5V24H.5a.472.472,0,0,0-.5.5v3a.472.472,0,0,0,.5.5H2v9H3V28H25V27H1V25H29v2H27.5a.472.472,0,0,0-.5.5V37h1V28h1.5a.472.472,0,0,0,.5-.5v-3A.472.472,0,0,0,29.5,24ZM10.85,15l-.8,2.1L9.25,15ZM5,17.5A2.476,2.476,0,0,1,7.5,15h.65l1.4,3.7A.506.506,0,0,0,10,19a.869.869,0,0,0,.55-.3l1.4-3.7h.55A2.476,2.476,0,0,1,15,17.5V24H13.5V19h-1v5h-5V19h-1v5H5V17.5Z" transform="translate(0 -7)" fill="#00b5ea" />
                                        <path id="Path_596" data-name="Path 596" d="M46.5,3h-12a.472.472,0,0,0-.5.5v7a.472.472,0,0,0,.5.5H37v2a.437.437,0,0,0,.3.45.3.3,0,0,0,.2.05.454.454,0,0,0,.35-.15L40.2,11h6.3a.472.472,0,0,0,.5-.5v-7A.472.472,0,0,0,46.5,3ZM46,10H40a.454.454,0,0,0-.35.15L38,11.8V10.5a.472.472,0,0,0-.5-.5H35V4H46Z" transform="translate(-17 -1.5)" fill="#00b5ea" />
                                        <rect id="Rectangle_580" data-name="Rectangle 580" width="3" height="1" transform="translate(19.5 4)" fill="#00b5ea" />
                                        <rect id="Rectangle_581" data-name="Rectangle 581" width="3" height="1" transform="translate(23.5 4)" fill="#00b5ea" />
                                        <rect id="Rectangle_582" data-name="Rectangle 582" width="8" height="1" transform="translate(19.5 6)" fill="#00b5ea" />
                                        <path id="Path_597" data-name="Path 597" d="M29.5,47h-5a.472.472,0,0,0-.5.5v3a.472.472,0,0,0,.5.5h5a.472.472,0,0,0,.5-.5v-3A.472.472,0,0,0,29.5,47ZM29,50H25V48h4Z" transform="translate(-12 -23.5)" fill="#00b5ea" />
                                        <rect id="Rectangle_583" data-name="Rectangle 583" width="1" height="1" transform="translate(20 24)" fill="#00b5ea" />
                                        <rect id="Rectangle_584" data-name="Rectangle 584" width="1" height="1" transform="translate(22 24)" fill="#00b5ea" />
                                        <rect id="Rectangle_585" data-name="Rectangle 585" width="1" height="1" transform="translate(24 24)" fill="#00b5ea" />
                                        <rect id="Rectangle_586" data-name="Rectangle 586" width="1" height="1" transform="translate(20 26)" fill="#00b5ea" />
                                        <rect id="Rectangle_587" data-name="Rectangle 587" width="1" height="1" transform="translate(22 26)" fill="#00b5ea" />
                                        <rect id="Rectangle_588" data-name="Rectangle 588" width="1" height="1" transform="translate(24 26)" fill="#00b5ea" />
                                        <rect id="Rectangle_589" data-name="Rectangle 589" width="1" height="1" transform="translate(5 24)" fill="#00b5ea" />
                                        <rect id="Rectangle_590" data-name="Rectangle 590" width="1" height="1" transform="translate(7 24)" fill="#00b5ea" />
                                        <rect id="Rectangle_591" data-name="Rectangle 591" width="1" height="1" transform="translate(9 24)" fill="#00b5ea" />
                                        <rect id="Rectangle_592" data-name="Rectangle 592" width="1" height="1" transform="translate(5 26)" fill="#00b5ea" />
                                        <rect id="Rectangle_593" data-name="Rectangle 593" width="1" height="1" transform="translate(7 26)" fill="#00b5ea" />
                                        <rect id="Rectangle_594" data-name="Rectangle 594" width="1" height="1" transform="translate(9 26)" fill="#00b5ea" />
                                    </g>
                                </svg>


                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-2 card-holder mb-4">
                    <div className="card p-2 card-05 h-100">
                        <div className="d-flex align-items-center">
                            <div className="left">
                                <h2 className="fw-bold">
                                    {overviewCount ? overviewCount.offeredCount : 0}
                                </h2>
                                <p className="mb-0">
                                    Offered
                                </p>
                            </div>
                            <div className="icon ms-auto">
                                <svg id="services-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <path id="Path_587" data-name="Path 587" d="M28.25,13.25h-2.5V12h2.5ZM2,13.25H4.5V12H2ZM24.057,7.075l1.769-1.767-.884-.884L23.174,6.193ZM4.425,5.309,6.194,7.077l.884-.884L5.309,4.425ZM15.75,4.5V2H14.5V4.5Zm0,18.75v2.5H27V27H3.25V25.75H14.5v-2.5H4.305A1.056,1.056,0,0,1,3.25,22.195,10.208,10.208,0,0,1,13.445,12H14.5V10.75H12V9.5h6.25v1.25h-2.5V12h1.055A10.208,10.208,0,0,1,27,22.195a1.056,1.056,0,0,1-1.055,1.055Zm10-1.25a8.955,8.955,0,0,0-8.943-8.75h-3.36A8.955,8.955,0,0,0,4.5,22Z" transform="translate(0.5 0.5)" fill="#91c684" />
                                    <path id="Path_588" data-name="Path 588" d="M0,0H30V30H0Z" fill="none" />
                                </svg>



                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-2 card-holder mb-4">
                    <div className="card p-2 card-06 h-100">
                        <div className="d-flex align-items-center">
                            <div className="left">
                                <h2 className="fw-bold">
                                    {overviewCount ? overviewCount.onBoardedCount : 0}
                                </h2>
                                <p className="mb-0">
                                    Onboarded
                                </p>
                            </div>
                            <div className="icon ms-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20.351" viewBox="0 0 30 20.351">
                                    <path id="handshake-thin-svgrepo-com" d="M36.692,59.514l-3.045-5.832a1.493,1.493,0,0,0-1.982-.641l-2.987,1.494H26.425l-4.183-1.893a1.488,1.488,0,0,0-1.028-.073L15,54.38l-2.944-1.472a1.493,1.493,0,0,0-1.982.641L7.029,59.381A1.486,1.486,0,0,0,7.682,61.4L10.7,62.906l6.729,5.262a1.475,1.475,0,0,0,.555.271l7.176,1.794a1.475,1.475,0,0,0,.357.044,1.494,1.494,0,0,0,1.054-.435l4.556-4.556.026-.028,1.916-2.241,2.971-1.485a1.486,1.486,0,0,0,.653-2.017ZM30.7,64.266l-5.078-3.693a.5.5,0,0,0-.589,0l-1.585,1.189a3.485,3.485,0,0,1-4.16,0l-.671-.5a.5.5,0,0,1-.053-.746l4.846-4.846a.5.5,0,0,1,.35-.145h4.738l3.669,7.025ZM7.875,60.221a.492.492,0,0,1,.032-.382l3.045-5.832a.5.5,0,0,1,.441-.265.489.489,0,0,1,.219.052l2.641,1.32-3.5,6.71L8.125,60.512A.491.491,0,0,1,7.875,60.221Zm17.994,8.92a.5.5,0,0,1-.471.13l-7.176-1.794a.491.491,0,0,1-.185-.09l-6.444-5.039,3.661-7.011L21.49,53.52a.5.5,0,0,1,.343.024l2.189.99h-.265a1.476,1.476,0,0,0-1.051.435L17.86,59.815a1.486,1.486,0,0,0,.159,2.239l.671.5a4.481,4.481,0,0,0,5.349,0l1.292-.969L30.016,65Zm9.977-8.788a.491.491,0,0,1-.25.291l-2.625,1.313-3.5-6.71,2.641-1.32a.5.5,0,0,1,.66.214l3.045,5.832a.492.492,0,0,1,.032.382ZM20.36,72.485a.495.495,0,0,1-.6.36l-3.732-.933a1.494,1.494,0,0,1-.615-.32L12.62,69.165a.5.5,0,0,1,.65-.748l2.793,2.427a.5.5,0,0,0,.205.107L20,71.884a.5.5,0,0,1,.36.6Z" transform="translate(-6.86 -52.509)" fill="#02ddac" />
                                </svg>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-8 left-details">
                    <div className="row mb-3">
                        <div className="col-12 col-md-4 ">
                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >
                                    Department
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.departmentName}</p>
                            </div>

                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >

                                    Account
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.accountName}</p>
                            </div>


                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >

                                    Company
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.companyNames?.join(", ") || ""}</p>
                            </div>

                        </div>
                        <div className="col-12 col-md-4 ">
                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >

                                    Job Owner(s)
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.ownerNames}</p>
                            </div>

                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >

                                    Account Manager
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.accountManagerNames}</p>
                            </div>


                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >

                                    Approved By
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.approverNames}</p>
                            </div>

                        </div>
                        <div className="col-12 col-md-4 ">
                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >

                                    Created By
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.createdbyusername}</p>
                            </div>

                            <div className="d-flex gap-2 align-items-center mb-3 overview-nodes">
                                <label className="form-label mb-0" >
                                    Created on
                                </label>
                                <span>:</span>
                                <p className="mb-0">{jobDetails?.createdAt ? new Date(jobDetails?.createdAt).toLocaleDateString('en-GB') : 'N/A'}</p>
                            </div>



                        </div>
                    </div>
                    <div className="expdble-container">
                        <button
                            onClick={toggleContent}
                            className="flex items-center justify-between w-full mb-2 text-left d-flex w-100"
                        >
                            <h6 className="m-0">Job Summary:</h6>

                            <IoChevronDown
                                className={`ms-auto transition-transform duration-200 ${isExpanded ? "rotate-180" : "rotate-0"
                                    }`}
                            />
                        </button>

                        {isExpanded && (
                            <div className="expandable-cont">
                                <p
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{ __html: jobDetails?.jobDescription || "" }}></p>
                            </div>
                        )}
                    </div>
                    {/* <h6 className="mb-2">Job Summary:</h6>
                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: jobDetails?.jobDescription || '' }}>
                       
                    </p> */}
                </div>
                <div className="col-12 col-md-4 right-activity">
                    <h6 className="mb-2">Job Activity</h6>
                    <JobActivity activities={jobActivities} />
                </div>
            </div>
            <hr className="dotted my-4" />
            <div className="candidate-list-info">
                <h5 className="mb-4">Candidates for #{jobDetails?.jobCode}</h5>

                <div className="row">
                    <div className="col-12 col-md-8 left-details">
                        <div className='datatable-holder'>
                            <DataTable
                                columns={columns}
                                data={candidateDetails}
                                conditionalRowStyles={[
                                    {
                                        when: (row) => row.candidateId === highlightedRowId, // Highlight the selected row
                                        classNames: ["highlighted-row"],
                                    },
                                ]}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 right-activity">
                        <h6 className="mb-2 primary-color">Candidate Activity{(candidateActivities && candidateActivities.length > 0) ? ` - ` : ''} <em>{candidateName}</em></h6>
                        <CandidateActivity activities={candidateActivities || []} candidateId={candidateId} />
                    </div>
                </div>
            </div>

        </section>
    );
}
